// Light/dark theme: follows prefers-color-scheme until the user toggles; the choice is persisted.
const KEY = 'pendant-theme'
const mq = window.matchMedia('(prefers-color-scheme: dark)')

/**
 * Stored manual choice, if any.
 * @returns {import('../types/pendant.js').ThemeMode | null}
 */
function stored() {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'light' || v === 'dark' ? v : null
  } catch {
    return null
  }
}

/**
 * Current effective theme.
 * @returns {import('../types/pendant.js').ThemeMode}
 */
export function currentTheme() {
  return stored() ?? (mq.matches ? 'dark' : 'light')
}

/**
 * Apply a theme to the document and notify listeners.
 * @param {import('../types/pendant.js').ThemeMode} mode theme to apply
 */
function apply(mode) {
  document.documentElement.dataset.theme = mode
  document.dispatchEvent(new CustomEvent('themechange', {detail: mode}))
  const btn = document.querySelector('#theme-toggle')
  if (btn) {
    btn.setAttribute('aria-pressed', String(mode === 'dark'))
    btn.setAttribute('aria-label', mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode')
  }
}

/** Wire up initial theme, system-preference changes and the toggle button. */
export function initTheme() {
  apply(currentTheme())
  mq.addEventListener('change', () => {
    if (!stored()) apply(currentTheme())
  })
  document.querySelector('#theme-toggle')?.addEventListener('click', () => {
    const next = currentTheme() === 'dark' ? 'light' : 'dark'
    try {
      localStorage.setItem(KEY, next)
    } catch {
      /* storage unavailable: theme still applies for this session */
    }
    apply(next)
  })
}
